import React from 'react';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import { QueryVal } from 'Helpers/Query';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import useHomeContext from 'Context/HomeContext';

const TOKEN_PARAM = 't';

function init() {
  return {
    token: QueryVal('t'),
    isLoggingIn: false,
    error: false,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'loginStarted': {
      return {
        ...state,
        isLoggingIn: true,
      };
    }
    case 'loginSucceeded': {
      return {
        ...state,
        isLoggingIn: false,
      };
    }
    case 'loginFailed': {
      return {
        ...state,
        isLoggingIn: false,
        error: action.error,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export default function useLoginTokenExperimental() {
  const { userResource, updateUserResource } = useUserContext();
  const { homeResource } = useHomeContext();
  const [state, dispatch] = React.useReducer(reducer, null, init);

  async function validateLoginToken(rel, token) {
    dispatch({ type: 'loginStarted' });
    try {
      // This is bad because it manipulates a relationship, but this will save a round trip and reduce the api surface area around authentication
      const [res] = await rel.link('related').copy().equal(TOKEN_PARAM, token).get({}, { deprecatedAllowAlterOfRelation: true });
      const [user] = await res.relationship(fr.relationships.user.name).link('related').get();
      updateUserResource(user);
      dispatch({ type: 'loginSucceeded' });
    } catch (err) {
      dispatch({ type: 'loginFailed', error: err });
    }
  }

  useComponentDidMount(() => {
    if (!state.token) {
      return;
    }
    if (!userResource) {
      const relationship = homeResource?.withRelationship(fr.relationships.planningAgreementToken.name, (rel) => rel, () => null);
      validateLoginToken(relationship, state.token);
    }
  });

  return {
    isLoggingIn: state.isLoggingIn,
    error: state.error,
  };
}
